import React from 'react';

import * as Styled from './toggle.style';

export type ToggleProps = Omit<React.ComponentProps<'input'>, 'value'> & {
  value: string | number;
  isSmall?: boolean;
};

export const Toggle: React.FC<ToggleProps> = ({
  id,
  isSmall,
  onKeyDown,
  ...rest
}) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    onKeyDown?.(event);
    if (event.key === 'Enter') {
      event.preventDefault();
      event.currentTarget.click();
    }
  };

  return (
    <Styled.Container htmlFor={id}>
      <Styled.Input
        type="checkbox"
        {...rest}
        id={id}
        $isSmall={!!isSmall}
        onKeyDown={handleKeyDown}
      />
      <Styled.ToggleLabel role="checkbox" htmlFor={id} $isSmall={!!isSmall} />
    </Styled.Container>
  );
};
